module.exports = __webpack_public_path__ + "static/img/closeIcon.f34d950.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/closeIcon.png
// module id = dJm9
// module chunks = 106